export default function Feature({
  type,
  data,
  last,
}: {
  type: "left" | "right";
  data: any;
  last: boolean;
}) {
  return type === "left" ? (
    <div
      className={`overflow-hidden ${
        last === true ? "pt-24 sm:pt-32 pb-44" : "py-24 sm:py-32"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pr-8 lg:pt-4">
            <div className="lg:max-w-lg">
              <h2 className="text-base font-semibold leading-7 text-info">
                {data.title}
              </h2>
              <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                {data.subtitle}
              </p>
              <p className="mt-6 text-lg leading-8 text-light">
                {data.description}
              </p>
              <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-light lg:max-w-none">
                {data.features.map((feature: any) => (
                  <div key={feature.name} className="relative pl-9">
                    <dt className="inline font-semibold text-white">
                      <feature.icon
                        className="absolute left-1 top-1 h-5 w-5 text-info"
                        aria-hidden="true"
                      />
                      {feature.name}
                    </dt>{" "}
                    <dd className="inline">{feature.description}</dd>
                  </div>
                ))}
              </dl>

              <div className="hidden mt-8 sm:flex justify-start">
                <div className="relative rounded-full px-3 py-1 text-sm leading-6 text-white ring-1 ring-secondary/30 hover:ring-light">
                  {data.action.text}{" "}
                  <a
                    href={data.action.url}
                    className="font-semibold text-primary"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="absolute inset-0" aria-hidden="true" />
                    {data.action.subtext} <span aria-hidden="true">&rarr;</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <img
            src={data.image}
            alt="Product screenshot"
            className="w-[48rem] max-w-none rounded-xl shadow-xl outline outline-secondary shadow-zinc-100/10 sm:w-[57rem] md:-ml-4 lg:-ml-0"
            width={2432}
            height={1442}
          />
        </div>
      </div>
    </div>
  ) : (
    <div
      className={`overflow-hidden ${
        last === true ? "pt-24 sm:pt-32 pb-44" : "py-24 sm:py-32"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:ml-auto lg:pl-4 lg:pt-4">
            <div className="lg:max-w-lg">
              <h2 className="text-base font-semibold leading-7 text-info">
                {data.title}
              </h2>
              <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                {data.subtitle}
              </p>
              <p className="mt-6 text-lg leading-8 text-light">
                {data.description}
              </p>
              <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-light lg:max-w-none">
                {data.features.map((feature: any) => (
                  <div key={feature.name} className="relative pl-9">
                    <dt className="inline font-semibold text-white">
                      <feature.icon
                        className="absolute left-1 top-1 h-5 w-5 text-info"
                        aria-hidden="true"
                      />
                      {feature.name}
                    </dt>{" "}
                    <dd className="inline">{feature.description}</dd>
                  </div>
                ))}
              </dl>

              <div className="hidden mt-8 sm:flex justify-start">
                <div className="relative rounded-full px-3 py-1 text-sm leading-6 text-white ring-1 ring-secondary/30 hover:ring-light">
                  {data.action.text}{" "}
                  <a
                    href={data.action.url}
                    className="font-semibold text-primary"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="absolute inset-0" aria-hidden="true" />
                    {data.action.subtext} <span aria-hidden="true">&rarr;</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-start justify-end lg:order-first">
            <img
              src={data.image}
              alt="Product screenshot"
              className="w-[48rem] max-w-none rounded-xl shadow-xl outline outline-secondary shadow-zinc-100/10 sm:w-[57rem]"
              width={2432}
              height={1442}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
